import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

interface Props {
  text: string | null;
  shrink?: boolean;
  className?: string;
  center?: boolean;
  large?: boolean;
}

export const ErrorMessage = ({ text, shrink, className, center, large }: Props) => {
  const cls = useStyles();

  return (
    <div className={clsx(
      cls.error,
      shrink && cls.shrink,
      center && cls.center,
      large && cls.large,
      className && className,
    )}>
      {text || ''}
    </div>
  );
};

const useStyles = makeStyles({
  error: {
    width: '100%',
    color: 'red',
    fontSize: 13,
    lineHeight: 1,
    padding: '2px 4px 0',
  },
  shrink: {
    lineHeight: 0.8,
  },
  center: {
    textAlign: 'center',
  },
  large: {
    fontSize: 18,
  },
});
